import { render, staticRenderFns } from "./mainHeader.vue?vue&type=template&id=4cf924ca&scoped=true&"
import script from "./mainHeader.vue?vue&type=script&lang=js&"
export * from "./mainHeader.vue?vue&type=script&lang=js&"
import style0 from "./mainHeader.vue?vue&type=style&index=0&id=4cf924ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf924ca",
  null
  
)

export default component.exports